import { SsMount } from 'src/js/dom/mount.js';
import { throttle } from 'lodash';
import $ from 'jquery';

export class SsPathFinder extends SsMount {
  constructor ( elm ) {
    super( elm );
    this.clickID = throttle( this.clickLsn.bind( this ), 200 );
    this.ID = this.elm.getAttribute( 'id' );
  }

  onClick () {
    this.$.on( 'click', this.clickID );
  }

  clickLsn () {
    this.rewrite();
    this.emit( 'path:click' );
  }

  getTitle () {
    const titleElms = this.elm.querySelectorAll( '.collection-title' );
    return Array.prototype.map.call( titleElms, elm => $( elm ).clone() );
  }

  rewrite () {
    const url = this.elm.getAttribute( 'data-href' );
    window.location.replace( url );
  }

  getID () {
    return this.elm.getAttribute( 'data-id' );
  }

  getData ( data ) {
    return this.elm.getAttribute( 'data-' + data );
  }
}
